import { Container } from 'react-bootstrap'
import Footer from './Footer'

function Terms() {
  return (
    <>
    <div className="container sub-page">
       <Container style={{ padding: "60px 0 0" }}>
      <h1 className='fw-bold'>Terms of Use</h1>
      <p className='mt-2'>
        Welcome to <strong>bankstatements</strong>. By using our website, you agree to these
        Terms of Use. Please read them carefully before accessing our services.
      </p>

      <h5 className='fw-bold mt-5'>1. Acceptance of Terms</h5>
      <p>
        By using this website, you agree to comply with and be bound by these
        terms. If you do not agree with any part, you must not use the site.
      </p>

      <h5 className='fw-bold mt-5'>2. Website Purpose</h5>
      <p>
        This site is intended for informational purposes only. We do not offer
        banking services directly. All content is based on publicly available
        information from Indian financial institutions.
      </p>

      <h5 className='fw-bold mt-5 '>3. User Conduct</h5>
      <ul className='pl-0' style={{color:"gray", fontSize:"16px"}}>
        <li>Do not use the website for any unlawful purpose.</li>
        <li>Do not attempt to access data not intended for you.</li>
        <li>Respect intellectual property and copyright rules.</li>
      </ul>

      <h5 className='fw-bold mt-5'>4. Intellectual Property</h5>
      <p>
        All content, including text, images, and graphics, is the property of
        banksstatements unless otherwise credited. You may not reuse or
        redistribute content without permission.
      </p>

      <h5 className='fw-bold mt-5'>5. Disclaimer</h5>
      <p>
        We strive to ensure the information is accurate, but we do not guarantee
        its completeness or timeliness. Users are advised to verify details with
        respective banks before making decisions.
      </p>

      <h5 className='fw-bold mt-5'>6. Limitation of Liability</h5>
      <p>
        We are not liable for any direct or indirect damages resulting from the
        use of this website, including data loss or service interruptions.
      </p>

      <h5 className='fw-bold mt-5'>7. Links to Third-Party Sites</h5>
      <p>
        Our site may contain links to external sites. We are not responsible for
        the content or practices of those websites.
      </p>

      <h5 className='fw-bold mt-5'>8. Modifications</h5>
      <p>
        We reserve the right to modify these Terms of Use at any time. Continued
        use of the site after updates implies your acceptance of those changes.
      </p>

      <h5 className='fw-bold mt-5'>9. Contact</h5>
      <p>
        If you have any questions about these terms, please email us at:
        <a href="mailto:support@banksstatements.com"> support@banksstatements.com</a>
      </p>
    </Container>
    </div>
    <Footer/>
    </>
  )
}

export default Terms
